import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "react-redux-form";
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from "../../../common/page-title";
import GameForm from './game-form';
import { getAdminGame, getAdminGameMeta } from "../../../../actions/games";
import { destandard } from "../../../../utils/commonFunctions";
import BackLink from '../../../common/back-link/index';

const model = 'deep.admin_game';

class GameFormPage extends Component {
  constructor(props) {
    super(props);

    const { match: { params: { id } } } = this.props;

    this.id = +id;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (this.isEdit()) {
      dispatch(getAdminGame(this.id)).then(() => {
        const { game } = this.props;
        const data = destandard({
          ...game.attributes
        });

        dispatch(actions.load(model, data));
      });
    } else {
      dispatch(getAdminGameMeta());
    }
  }
  
  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset(model));
  }

  isEdit = () => {
    return !!this.id;
  };

  render() {
    const { isLoading, game, meta } = this.props;

    return(
      <Grid bsClass="container" fluid>
        <Row>
          <Col md={12}>
            <BackLink href="/admin/games"/>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PageTitle>Games</PageTitle>
          </Col>
        </Row>
        {isLoading ?
          'Loading...' :
          <GameForm
            model={model}
            id={this.id}
            isEdit={this.isEdit()}
            groups={meta.groups}
            products={meta.products}
            gameLevels={game.attributes && Object.values(game.attributes['game-levels']) || []}
            links={game.attributes && game.attributes.links || null} />
        }
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: !state.games.fetched && state.games.fetching,
  game: state.games.game,
  meta: state.games.meta
});

export default connect(mapStateToProps)(GameFormPage);



// WEBPACK FOOTER //
// ./src/components/admin/games/form/index.jsx